module.exports = __webpack_public_path__ + "img/PB_Logo_Wide.2b634d9.svg";